import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';

const makeImageUrl = (cdnUrl, marketId, type, name, width, extension) =>
  `${cdnUrl}image/${type}/${marketId}/${name}.${extension}?w=${width}`;

const CdnImage = ({ type, name, width, alt }) => {
  const { market = { imageCdnUrl: '', code: '' } } = useContext(AppContext);
  return (
    <picture alt={alt}>
      <source
        srcSet={makeImageUrl(
          market.imageCdnUrl,
          market.code,
          type,
          name,
          width,
          'webp'
        )}
        type="image/webp"
      />
      {/* Safari fallback */}
      <source
        srcSet={makeImageUrl(
          market.imageCdnUrl,
          market.code,
          type,
          name,
          width,
          'png'
        )}
        type="image/png"
      />
      {/* IE fallback */}
      <img
        src={makeImageUrl(
          market.imageCdnUrl,
          market.code,
          type,
          name,
          width,
          'png'
        )}
        alt={alt}
      />
    </picture>
  );
};

export const cdnImageTypes = {
  store: 'store',
};

const { string, number, oneOf, oneOfType } = PropTypes;

CdnImage.propTypes = {
  type: oneOf(Object.values(cdnImageTypes)).isRequired,
  name: oneOfType([string, number]).isRequired,
  width: number.isRequired,
  alt: string,
};

CdnImage.defaultProps = {
  alt: undefined,
};

export default memo(CdnImage);
